import * as Yup from 'yup'
import { LANDSCAPE_IMAGE } from '../../../../fields'
import { listOfImagesShape } from '../../../../validations'

export const validationSchema = Yup.object({
  [LANDSCAPE_IMAGE]: listOfImagesShape
})
